const data = 
[
    { 
        name: "Nutrition",
        slug: "nutrition",
        text: "",
        bg: "bg-nutrition",
        icon: "/images/categories/img-nutrition-01.svg"
    },
    { 
        name: "Beauty",
        slug: "beauty",
        text: "",
        icon: "/images/categories/img-beauty-01.svg"
    },
    {
        name: "Body & Mind",
        slug: "body-and-mind",
        text: "",
        icon: "/images/categories/img-body-and-mind-01.svg"     
    },
    { 
        name: "Green Home",
        slug: "green-home",
        text: "",
        icon: "/images/categories/img-green-home-01.svg"
    },
    { 
        name: "Sports & Fitness",
        slug: "sports-and-fitness",
        text: "",
        bg: "bg-nutrition",
        icon: "/images/categories/img-sports-and-fitness-01.svg"
    },
    { 
        name: "Healthy Weight",
        slug: "healthy-weight",
        text: "",
        icon: "/images/categories/img-healthy-weight-01.svg"
    },
    { 
        name: "Kids' Health",
        slug: "kids-health",
        text: "",
        icon: "/images/categories/img-healthy-kids-01.svg"
    },
    { 
        name: "Women's Health",
        slug: "womens-health",
        text: "",
        icon: "/images/categories/img-womens-health-01.svg"
    },
    { 
        name: "Men's Health",
        slug: "mens-health",
        text: "",
        icon: "/images/categories/img-mens-health-01.svg"
    },
    { 
        name: "Shaklee Focused",
        slug: "shaklee-focused",
        text: "",
        bg: "bg-shaklee-focused",
        icon: "/images/categories/img-shaklee-focused-02.svg"
    },
    // {
    //     name: "Recipes",
    //     slug: "recipes",
    //     text: "This is text to add to this section so it looks better.",
    //     icon: "/images/sections/img-recipes-01.svg",
    // },
    // { 
    //     name: "Healthy Pregnancy",
    //     slug: "healthy-pregnancy",
    //     text: "This is text to add to this section so it looks better.",
    //     icon: "/images/categories/img-healthy-pregnancy-01.svg"
    // },
    // { 
    //     name: "Shaklee Focused",
    //     slug: "shaklee-focused",
    //     text: "This is text to add to this section so it looks better.",
    //     icon: "/images/categories/img-shaklee-focused-01.svg"
    // },
]
export default data